import { pathgen } from 'object-path-generator';
export const SuggestedDescriptionDisplayTestIds = pathgen('SuggestedDescriptionDisplayTestIds');
export const DESCRIPTION_PROMPT = 'How would you like to change this description?';
export const isPromptQuestion = description => description === DESCRIPTION_PROMPT;